



























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IComment } from "../../types/comment.model";

@Component({
  mounted() {
    this.$data.isActive = true;
  },
})
export default class ReportModal extends Vue {
  @Prop({ type: Function }) onConfirm!: (
    content: string,
    forward: boolean
  ) => void;

  @Prop({ type: String }) title!: string;

  @Prop({ type: Object }) comment!: IComment;

  @Prop({ type: String, default: "" }) outsideDomain!: string;

  @Prop({ type: String }) cancelText!: string;

  @Prop({ type: String }) confirmText!: string;

  isActive = false;

  content = "";

  forward = false;

  get translatedCancelText(): string {
    return this.cancelText || (this.$t("Cancel") as string);
  }

  get translatedConfirmText(): string {
    return this.confirmText || (this.$t("Send the report") as string);
  }

  confirm(): void {
    this.onConfirm(this.content, this.forward);
    this.close();
  }

  /**
   * Close the Dialog.
   */
  close(): void {
    this.isActive = false;
    this.$emit("close");
  }
}
